import classnames from 'classnames';
import React from 'react';
import './thumbnailHRS.styles.scss';
import useThumbnailHRS from './useThumbnailHRS';

export type ThumbnailHRSProps = {
  overlayContent?: React.ReactNode;
  id: number | string;
  // Optional: the useEffect below only calls drawStrip when ecgData?.length > 0,
  // and width/height are otherwise only passed straight through as SVG attrs.
  ecgData?: number[][];
  channels?: number[];
  gain?: number;
  speed?: number;
  width?: number;
  height?: number;
  className?: string;
  highPass?: number;
  beatMarkers?: number[];
  hesBeatStatus?: number[];
  // accepted but intentionally ignored — the button below is always disabled

  disabled?: boolean;
};

/**
 * Renders a single heart-rate summary thumbnail as a disabled button wrapping an SVG canvas. Passes the props to useThumbnailHRS, which owns the canvas ref used to draw the trace, and places any overlayContent above it.
 *
 * @param props - Thumbnail identity, sizing, class name and optional overlay content.
 * @returns The heart-rate thumbnail button containing its SVG canvas.
 */
const ThumbnailHRS = ({
  overlayContent = null,
  id,
  ecgData,
  channels,
  gain,
  speed,
  width,
  height,
  className,
  highPass,
  beatMarkers,
  hesBeatStatus,
}: ThumbnailHRSProps) => {
  const { canvasRef } = useThumbnailHRS({
    ecgData,
    channels,
    gain,
    speed,
    width,
    height,
    highPass,
    beatMarkers,
    hesBeatStatus,
  });

  return (
    <button
      id={id as string}
      disabled
      aria-label="Heart rate strip thumbnail"
      className={classnames('single-strip-hr', className)}
    >
      {overlayContent}
      <svg ref={canvasRef} width={width} height={height} />
    </button>
  );
};

export default ThumbnailHRS;
